var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector43(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 402,
    viewBox: "0 0 224 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.969 400.745C198.115 374.213 194.363 368.666 179.854 342.969C176.299 336.673 170.998 324.658 166.366 310.083C164.978 305.721 163.766 301.419 162.695 297.194C155.065 266.963 157.88 234.674 164.974 203.384C183.078 123.55 149.473 44.5593 86.2131 14.1063C22.8361 -16.4209 -55.6713 8.38967 -99.2016 58.0575C-104.865 64.5203 -130.152 95.217 -138.315 131.616C-164.121 246.534 -57.9558 308.632 108.514 367.605C111.753 368.75 127.262 373.556 130.565 374.489L222.98 400.746L222.969 400.745Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector43);
export default __webpack_public_path__ + "static/media/vector4-3.09ca8caae5b9cf7f025660f6164c0315.svg";
export { ForwardRef as ReactComponent };